import { Provider } from '@angular/core';
import { HistoryDataHttpService } from './abstract';
import { HistoryDataHttpServiceImpl } from './history-data-http.service';

export const HistoryDataHttpProvider: Provider = {
	provide: HistoryDataHttpService,
	useClass: HistoryDataHttpServiceImpl,
};
